import React, { useContext, useEffect, useState } from "react";
import ResultChip from "../../../ResultChip";
import { formatDate, scrollIntoView } from "../../../../utils/func";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { filterDataContext } from "../../../../App";
import { EVENTSPAGE } from "../../../../constants/RoutingPath";
import { DownArrowIcon, RightArrowIcon } from "../../../GlobalIcons";
import NoResultFound from "../../../NoResultFound";

const ChipsSec = ({
  searchResult,
  createFilterParams,
  currentSortingTab,
  popularData,
  filteredEvents,
  showSorting,
  setShowSorting,
  setSearchParams,
  searchParams,
  handleOpenEvent,
}) => {
  const {
    setViewMoreClicked,
    setBottomSheetView,
    filterSearchInput,
    filterLoader,
  } = useContext(filterDataContext);
  const navigate = useNavigate();
  const itemsPerPage = 10;
  const [visibleItems, setVisibleItems] = useState(itemsPerPage);

  useEffect(() => {
    if (filterSearchInput.length > 0) {
      setVisibleItems(itemsPerPage);
    }
  }, [filterSearchInput]);

  const handleEventRouting = () => {
    navigate({
      pathname: EVENTSPAGE,
      search: createSearchParams(searchParams).toString(),
    });
    setBottomSheetView(false);
    setShowSorting(!showSorting);
    setViewMoreClicked(true);
  };

  const showMoreItems = () => {
    const newVisibleItems = visibleItems + itemsPerPage;
    setVisibleItems(Math.min(newVisibleItems, searchResult.length));
  };

  return (
    <>
      {filterLoader === true ? (
        <ResultChip filterLoader={filterLoader} />
      ) : (
        <div
          className="chips_sec"
          style={{ display: "flex", columnGap: "10px", cursor: "pointer" }}
        >
          {searchResult &&
            (searchResult.length > 0 ? (
              <>
                {searchResult.slice(0, visibleItems).map((item, index) => (
                  <ResultChip
                    name={
                      item.event_name ? item.event_name : item.official_name
                    }
                    key={index}
                    item={item}
                    createFilterParams={createFilterParams}
                    detail={
                      currentSortingTab === "Competition" &&
                      formatDate(item.date_start)
                    }
                  />
                ))}
                {searchResult.length > 5 &&
                searchResult.length > visibleItems ? (
                  <button className="view_more_filter" onClick={showMoreItems}>
                    View More
                    <span>
                      <DownArrowIcon fill={"var(--black)"} />
                    </span>
                  </button>
                ) : (
                  ""
                )}
              </>
            ) : (
              <NoResultFound heading={"No Search Result Found"} />
            ))}

          {popularData &&
            popularData?.map((item, index) => {
              return (
                <ResultChip
                  name={
                    item.venue_Name
                      ? item.venue_Name
                      : item.official_name
                      ? item.official_name
                      : ""
                  }
                  key={index}
                  item={item}
                  createFilterParams={createFilterParams}
                  detail={
                    (currentSortingTab === "Location" &&
                      `${item.city} (${item.country})`) ||
                    (currentSortingTab === "Competition" &&
                      formatDate(item.date_start))
                  }
                />
              );
            })}

          {filteredEvents &&
            (filteredEvents.length > 0 ? (
              <>
                {filteredEvents.slice(0, 5).map((item, index) => (
                  <ResultChip
                    name={item.event_name}
                    key={index}
                    item={item}
                    detail={formatDate(item.date_start)}
                    handleOpenEvent={handleOpenEvent}
                  />
                ))}
                {filteredEvents.length > 5 && (
                  <button
                    className="view_more_filter"
                    onClick={handleEventRouting}
                  >
                    View More
                    <span>
                      <DownArrowIcon fill={"var(--black)"} />
                    </span>
                  </button>
                )}
              </>
            ) : (
              <NoResultFound heading={"No Events Founds"} />
            ))}
        </div>
      )}
    </>
  );
};

export default ChipsSec;
